export default __webpack_public_path__ + "static/media/622.eefaf4f4.jpg";